const WORDS = ["Cerramientos", "Mosquiteras a medida", "Persianas", "Cerrajería", "Reparaciones", "Puertas PVC"];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <div className="bg-ink py-6 overflow-hidden border-y border-white/10" data-testid="marquee">
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="inline-flex items-center font-heading font-extrabold text-2xl md:text-4xl text-white/90 mx-8">
            {w}
            <span className="w-2 h-2 rounded-full bg-electric ml-16" />
          </span>
        ))}
      </div>
    </div>
  );
};
